import React from 'react'
import {capitalize} from 'admin/lib/format'

export default (Component, {onSort, sortBy, sortDirection, camelcase = false}) => ({name, column, className}) => {
  const handleSort = e => {
    e.preventDefault()
    let newDirection = sortDirection && sortDirection === 'desc' ? 'asc' : 'desc'
    if (camelcase) {
      onSort({['sortBy']: column || name, ['sortDirection']: newDirection})
    } else {
      onSort({['sort_by']: column || name, ['sort_direction']: newDirection})
    }
  }

  return (
    <Component className={className}>
      {sortBy == (column || name) ? (
        <a href='' className='icon-text' onClick={handleSort}>
          <span className='mr-2'>{capitalize(name)}</span>
          <span className='icon'>
            <i className={`fa ${sortDirection === 'desc' ? 'fa-caret-down' : 'fa-caret-up'}`}></i>
          </span>
        </a>
      ) : (
        <a href='' className='icon-text' onClick={handleSort}>
          {capitalize(name)}
        </a>
      )}
    </Component>
  )
}
